import { API } from "@/common/api";
class dataService {
  private seccionID: number = 3;
  private ambiente: string = "prod";
  private url: { [key: string]: string } = {
    local: "http://localhost:3000/",
    dev: "https://dtlw929urc.execute-api.us-east-1.amazonaws.com/",
    prod: "https://zhy1elgywc.execute-api.us-east-1.amazonaws.com/",
  };

  getByID(id: any): Promise<any> {
    let getID = {
      params: { id: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/proveedores/{{id}}",
      getID
    );
  }

  getAllProvider(qryOffset: any, qryLimit: any, qrySearch: any): Promise<any> {
    let allProvider = {
      params: {},
      data: {
        queryOffset: qryOffset,
        queryLimit: qryLimit,
        querySearch: qrySearch,
      },
    };
    return API.post(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/proveedores",
      allProvider
    );
  }

  getProviderObra(id: any, pObra: any): Promise<any> {
    let getObra = {
      params: {},
      data: { proveedor: id, isProveedorSCObra: pObra },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/proveedores/updSubcontratacionObra",
      getObra
    );
  }

  // DOCUMENTO
  getDocument(id: any) {
    let getDoc = {
      params: { id: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/{{id}}",
      getDoc
    );
  }

  getDocumentProvider(provider: any, type: any) {
    let getDocProvider = {
      params: { proveedor: provider, tipo: type },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/proveedor/{{proveedor}}/{{tipo}}",
      getDocProvider
    );
  }

  createDocument(registro: any) {
    let createDoc = {
      params: {},
      data: {
        descripcion: registro.docDescripcion,
        proveedor: registro.docProveedor,
        vigenciaIni: registro.docVigenciaIni,
        vigenciaFin: registro.docVigenciaFin,
        tipo: registro.docTipoID,
        file: registro.docBucketKeyFile,
        fileExt: registro.docFileExt,
        docOC: registro.docOCNumero,
        docEsTermCond: registro.docEsTermCond,
        empresa: registro.docEmpresaClave,
        factura: registro.docFactura,
      },
    };
    return API.post(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/crear",
      createDoc,
      true
    );
  }

  updateDocument(registro: any) {
    let updDoc = {
      params: {},
      data: {
        id: registro.docID,
        descripcion: registro.docDescripcion,
        proveedor: registro.docProveedor,
        vigenciaIni: registro.docVigenciaIni,
        vigenciaFin: registro.docVigenciaFin,
        tipo: registro.docTipoID,
        file: registro.docBucketKeyFile,
        fileExt: registro.docFileExt,
        docOC: registro.docOCNumero,
        docEsTermCond: registro.docEsTermCond,
        empresa: registro.docEmpresaClave,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/actualizar",
      updDoc,
      true
    );
  }

  deleteDocument(id: any) {
    let delDoc = {
      params: { id: id },
      data: {},
    };
    return API.delete(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/{{id}}",
      delDoc
    );
  }

  // REGISTRO STPS
  getRegisterSTPSProvider(provider: any) {
    let getResSTPSProv = {
      params: { provider: provider },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/proveedor/{{provider}}",
      getResSTPSProv
    );
  }

  getRegisterSTPS(id: any) {
    let getResSTPS = {
      params: { id: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/{{id}}",
      getResSTPS
    );
  }

  deleteRegisterSTPS(id: any) {
    let delResSTPS = {
      params: { id: id },
      data: {},
    };
    return API.delete(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/{{id}}",
      delResSTPS
    );
  }

  createRegisterSTPS(registro: any) {
    let createResSTPS = {
      params: {},
      data: {
        numero: registro.registroSTPSNumero,
        proveedor: registro.registroSTPSProveedor,
        vigenciaIni: registro.registroSTPSVigenciaIni,
        vigenciaFin: registro.registroSTPSVigenciaFin,
        tipo: registro.docTipoID,
        file: registro.registroSTPSBucketKeyFile,
        fileExt: registro.registroSTPSFileExt,
      },
    };
    return API.post(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/crear",
      createResSTPS,
      true
    );
  }

  updateRegisterSTPS(registro: any) {
    let updResSTPS = {
      params: {},
      data: {
        id: registro.registroSTPSID,
        numero: registro.registroSTPSNumero,
        proveedor: registro.registroSTPSProveedor,
        vigenciaIni: registro.registroSTPSVigenciaIni,
        vigenciaFin: registro.registroSTPSVigenciaFin,
        tipo: registro.docTipoID,
        file: registro.registroSTPSBucketKeyFile,
        fileExt: registro.registroSTPSFileExt,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/actualizar",
      updResSTPS,
      true
    );
  }

  // REGISTRO PATRONAL
  getEmployerRegister(id: any) {
    let getEmployer = {
      params: { id: id },
      data: {},
    };

    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/{{id}}",
      getEmployer
    );
  }

  getEmployerProvider(id: any) {
    let getEmProvider = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/proveedor/{{proveedor}}",
      getEmProvider
    );
  }

  createEmployerRegister(registro: any) {
    let createEmployerRes = {
      params: {},
      data: {
        numero: registro.registroPatronalNumero,
        proveedor: registro.registroPatronalProveedor,
        matriz: registro.registroPatronalMatriz,
        cp: registro.registroPatronalCodigoP,
        totalTrabajadores: registro.registroPatronalTotalTabajadores,
        tipo: registro.docTipoID,
        file: registro.registroPatronalBucketKeyFile,
        fileExt: registro.registroPatronalFileExt,
        vigenciaIni: registro.registroPatronalVigenciaIni,
        vigenciaFin: registro.registroPatronalVigenciaFin,
      },
    };
    return API.post(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/crear",
      createEmployerRes,
      true
    );
  }

  updateEmployerRegister(registro: any) {
    let updEmployerRes = {
      params: {},
      data: {
        id: registro.registroPatronalID,
        numero: registro.registroPatronalNumero,
        proveedor: registro.registroPatronalProveedor,
        matriz: registro.registroPatronalMatriz,
        cp: registro.registroPatronalCodigoP,
        totalTrabajadores: registro.registroPatronalTotalTabajadores,
        tipo: registro.docTipoID,
        file: registro.registroPatronalBucketKeyFile,
        fileExt: registro.registroPatronalFileExt,
        vigenciaIni: registro.registroPatronalVigenciaIni,
        vigenciaFin: registro.registroPatronalVigenciaFin,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/actualizar",
      updEmployerRes,
      true
    );
  }

  deleteEmployerRegister(id: any) {
    let delEmployerRes = {
      params: { id: id },
      data: {},
    };
    return API.delete(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/{{id}}",
      delEmployerRes
    );
  }

  //  ACTIVIDADES
  getActivitiesProvider(provider: any) {
    let getActivitiesProvider = {
      params: { proveedor: provider },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/proveedor/{{proveedor}}",
      getActivitiesProvider
    );
  }

  getActivitiesSTPS(id: any) {
    let getActivitiesProvider = {
      params: { id: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/stps/{{id}}",
      getActivitiesProvider
    );
  }

  getActivities(id: any) {
    let getActivities = {
      params: { id: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/{{id}}",
      getActivities
    );
  }

  createActivities(registro: any) {
    let createActivities = {
      params: {},
      data: {
        folio: registro.registroActividadFolio,
        descripcion: registro.registroActividadDescripcion,
        idRegistroSTPS: registro.registroActividadRSTPSID,
      },
    };
    return API.post(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/crear",
      createActivities
    );
  }

  updateActivities(registro: any) {
    let updActivities = {
      params: {},
      data: {
        id: registro.registroActividadID,
        folio: registro.registroActividadFolio,
        descripcion: registro.registroActividadDescripcion,
        idRegistroSTPS: registro.registroActividadRSTPSID,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/actualizar",
      updActivities
    );
  }

  deleteActivities(id: any) {
    let delActivitites = {
      params: { id: id },
      data: {},
    };
    return API.delete(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/{{id}}",
      delActivitites
    );
  }

  //  SECCION DE DOCUMENTOS
  getSectionDocuments() {
    let payload = {
      params: { id: this.seccionID },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentoSeccion/{{id}}",
      payload
    );
  }

  getSectionDocuments1(seccionID: any) {
    let payload = {
      params: { id: seccionID },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentoSeccion/{{id}}",
      payload
    );
  }

  //  SOCIEDADES
  getCompany() {
    let payload = {
      params: { id: "" },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/sociedades",
      payload
    );
  }

  // TERMINOS Y CONDICIONES
  getContractList() {
    let payload = {
      params: { id: "" },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/registrosProveedor",
      payload
    );
  }

  getTermsConditions() {
    let payload = {
      params: { id: "" },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/terminosCondiciones",
      payload
    );
  }

  //  FACTURAS
  getAllInvoices() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/facturasOC",
      payload
    );
  }

  getInvoice(provider: any) {
    let payload = {
      params: { id: provider },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/facturasOC/{{id}}",
      payload
    );
  }

  getInvoiceBySupplier(id: any, tipo: any) {
    let payload = {
      params: {
        id: id,
        tipo: tipo,
      },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        "dev/api/documentos/proveedor/{{id}}/{{tipo}}   ",
      payload
    );
  }

  getInvoiceBySupplierAndInvoice(id: any, tipo: any, factura: any) {
    let payload = {
      params: {
        id: id,
        tipo: tipo,
        factura: factura,
      },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        "dev/api/documentos_facturas/{{id}}/{{tipo}}/{{factura}}",
      payload
    );
  }

  //  PAGOS
  getPaymentFolio(serie: any, folio: any) {
    let payload = {
      params: {
        serie: serie,
        folio: folio,
      },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        "dev/api/documentos/factura_pago/{{serie}}/{{folio}}",
      payload
    );
  }

  getFilePayment(id: any, ext: any) {
    let payload = {
      params: {
        id: id,
        ext: ext,
      },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] + "dev/api/documentos/pago/{{id}}/{{ext}}",
      payload
    );
  }

  //      Autorización

  approveRegisterSTPS(id: any) {
    let payload = {
      params: { id: id },
      data: {},
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/aprobar/{{id}}",
      payload
    );
  }

  refuseRegisterSTPS(id: any, motive: any) {
    let payload = {
      params: {},
      data: {
        id: id,
        motivoRechazo: motive,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registro_stps/rechazar",
      payload
    );
  }

  approveEmployerRegister(id: any) {
    let payload = {
      params: { id: id },
      data: {},
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/aprobar/{{id}}",
      payload
    );
  }

  refuseEmployerRegister(id: any, motive: any) {
    let payload = {
      params: {},
      data: {
        id: id,
        motivoRechazo: motive,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/registropatronal/rechazar",
      payload
    );
  }

  approveDocuments(id: any) {
    let payload = {
      params: { id: id },
      data: {},
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/aprobar/{{id}}",
      payload
    );
  }

  refuseDocuments(id: any, motive: any) {
    let payload = {
      params: {},
      data: {
        id: id,
        motivoRechazo: motive,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/documentos/rechazar",
      payload
    );
  }

  approveActivities(id: any) {
    let payload = {
      params: { id: id },
      data: {},
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/aprobar/{{id}}",
      payload
    );
  }

  refuseActivities(id: any, motive: any) {
    let payload = {
      params: {},
      data: {
        id: id,
        motivoRechazo: motive,
      },
    };
    return API.put(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/actividades/rechazar",
      payload
    );
  }
  // API DE REPORTES
  /** Pendientes por subir */
  getMainReport() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/general",
      payload
    );
  }
  /** Pendientes por autorizar */
  getMainReportPending() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/general/pendientes",
      payload
    );
  }
  /** Rechazados */
  getMainReportRefuse() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/general/rechazados",
      payload
    );
  }
  /** Pendientes por subir (proveedor) */
  getMainReportSupp(id: any) {
    let payload = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes_general/{{proveedor}}",
      payload
    );
  }
  /** Pendientes por autorizar (proveedor) */
  getMainReportPendingSupp(id: any) {
    let payload = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes_general/pendientes/{{proveedor}}",
      payload
    );
  }
  /** Rechazados (proveedor) */
  getMainReportRefuseSupp(id: any) {
    let payload = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes_general/rechazados/{{proveedor}}",
      payload
    );
  }
  /** lista de proveedores con pendientes por subir */
  getReportMissingDoc() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/documentos_faltantes",
      payload
    );
  }
  /** lista de proveedores con pendientes por autorizar */
  getReportPendingDoc() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/documentos_pendientes",
      payload
    );
  }
  /** lista de proveedores con documentos rechazados */
  getReportRefuseDoc() {
    let payload = {
      params: {},
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/documentos_rechazados",
      payload
    );
  }
  /** lista de documentos pendientes por subir por proveedor */
  getReportMissingDocSupp(id: any) {
    let payload = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/documentos_faltantes/{{proveedor}}",
      payload
    );
  }
  /** lista de documentos con pendientes por autorizar por proveedor */
  getReportPendingDocSupp(id: any) {
    let payload = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/documentos_pendientes/{{proveedor}}",
      payload
    );
  }
  /** lista de documentos rechazados por proveedor */
  getReportRefuseDocSupp(id: any) {
    let payload = {
      params: { proveedor: id },
      data: {},
    };
    return API.get(
      this.url[this.ambiente] +
        (this.ambiente == "local" ? "dev" : this.ambiente) +
        "/api/reportes/documentos_rechazados/{{proveedor}}",
      payload
    );
  }
}

export default new dataService();
